module.exports = __webpack_public_path__ + "img/filter.f103484b.svg";